module.exports = __webpack_public_path__ + "img/manageit-digital_logoWhite.d6b1e15c.png";